import { Button, Divider, Flex, Input, List, message, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
const { Title, Text, Paragraph } = Typography

import TextArea from 'antd/es/input/TextArea'
import { useParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import {
  addCommunityGuidebook,
  deleteCommunityGuidebook,
  getCommunityGuidebook,
  getCommunityInfo,
  updateCommunityGuidebook,
  updateCommunityInfo,
} from '../../api/community.api'
import ContentHeader from '../../components/shared/ContentHeader'
import styles from '../../styles/sales.module.scss'

export default function CommunityUpdatePage() {
  const { categoryId, communityId } = useParams()
  const [content, setContent] = useState(null)
  const [guidebookList, setGuidebookList] = useState([])
  const [newGuideTitle, setNewGuideTitle] = useState('')
  const [newGuideDescription, setNewGuideDescription] = useState('')
  const [newGuideLink, setNewGuideLink] = useState('')
  const [isRegisteringGuide, setIsRegisteringGuide] = useState(false)

  /**
   * 커뮤니티 안내 문구 수정
   */
  const handleEditCommunityInfo = async () => {
    Swal.fire({
      text: '커뮤니티 안내 문구를 수정하시겠습니까?',
      showCancelButton: true,
      confirmButtonText: '수정',
      cancelButtonText: '취소',
    }).then(async (result) => {
      if (result.isConfirmed) {
        await editCommunityInfo()
      }
    })
  }
  const editCommunityInfo = async () => {
    try {
      const res = await updateCommunityInfo(communityId, content)

      message.success('커뮤니티 안내 문구가 수정되었습니다.')
    } catch (error) {
      console.error(error)
    }
  }

  /**
   * 커뮤니티 안내 문구 조회
   */
  const fetchCommunityInfo = async () => {
    try {
      const res = await getCommunityInfo(communityId)
      setContent(res?.content ?? '')
    } catch (error) {
      console.error(error)
      return null
    }
  }
  useEffect(() => {
    fetchCommunityInfo()
  }, [communityId])

  /**
   * 가이드북 조회
   */
  const fetchCommunityGuidebook = async () => {
    try {
      const res = await getCommunityGuidebook(categoryId)
      setGuidebookList(
        Array.isArray(res?.content)
          ? res.content
          : Array.isArray(res)
            ? res
            : [],
      )
    } catch (error) {
      console.error(error)
      setGuidebookList([])
      return
    }
  }
  useEffect(() => {
    fetchCommunityGuidebook()
  }, [categoryId])

  const registerCommunityGuidebook = async () => {
    const title = (newGuideTitle || '').trim()
    const description = (newGuideDescription || '').trim()
    const link = (newGuideLink || '').trim()
    if (!title || !link) {
      message.warning('제목과 링크를 입력해주세요.')
      return
    }
    setIsRegisteringGuide(true)
    try {
      await addCommunityGuidebook({ categoryId, title, description, link })
      message.success('가이드북이 등록되었습니다.')
      setNewGuideTitle('')
      setNewGuideDescription('')
      setNewGuideLink('')
      fetchCommunityGuidebook()
    } catch (error) {
      console.error(error)
      const fallback =
        error?.response?.data?.detail?.[0]?.description ||
        '가이드북 등록에 실패했습니다.'
      message.error(fallback)
    } finally {
      setIsRegisteringGuide(false)
    }
  }

  const handleUpdateCommunityGuidebook = async (
    guideId,
    titleArg,
    descriptionArg,
    linkArg,
  ) => {
    const title = (titleArg || '').trim()
    const description = (descriptionArg || '').trim()
    const link = (linkArg || '').trim()
    if (!title || !link) {
      message.warning('제목과 링크를 입력해주세요.')
      return
    }
    try {
      await updateCommunityGuidebook(guideId, { title, description, link })
      message.success('가이드북이 수정되었습니다.')
      fetchCommunityGuidebook()
    } catch (error) {
      console.error(error)
      const fallback =
        error?.response?.data?.detail?.[0]?.description ||
        '가이드북 수정에 실패했습니다.'
      message.error(fallback)
    }
  }

  const handleDeleteCommunityGuidebook = async (guideId) => {
    Swal.fire({
      text: '가이드북을 삭제하시겠습니까?',
      showCancelButton: true,
      confirmButtonText: '삭제',
      cancelButtonText: '취소',
    }).then(async (result) => {
      if (result.isConfirmed) {
        await deleteCommunityGuidebook(guideId)
        message.success('가이드북이 삭제되었습니다.')
        fetchCommunityGuidebook()
      }
    })
  }
  return (
    <div>
      <ContentHeader title="커뮤니티 정보 조회/수정" />
      <div style={{ padding: '0 24px' }}>
        <Flex
          justify="space-between"
          align="center"
          style={{
            background: '#f8fafd',
            borderRadius: 10,
            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
            padding: '18px 24px',
            marginTop: 24,
            marginBottom: 18,
            gap: 16,
          }}
        >
          <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <Title level={4} style={{ margin: 0 }}>
              💌 커뮤니티 안내 문구 수정
            </Title>
          </div>
          <Button type="primary" onClick={handleEditCommunityInfo}>
            수정
          </Button>
        </Flex>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{ marginBottom: 16, padding: '16px', background: '#fff' }}
        >
          <TextArea
            rows={4}
            placeholder="내용을 입력해주세요."
            name="content"
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />
        </div>
      </div>
      <Divider className={`${styles['product-register-form-input-divider']}`} />

      <div style={{ padding: '0 24px' }}>
        <Flex
          justify="space-between"
          align="center"
          style={{
            background: '#f8fafd',
            borderRadius: 10,
            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
            padding: '18px 24px',
            marginTop: 24,
            marginBottom: 18,
            gap: 16,
          }}
        >
          <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <Title level={4} style={{ margin: 0 }}>
              👩🏻‍💻 커뮤니티 가이드북 수정
            </Title>
          </div>
        </Flex>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{ marginBottom: 16, padding: '16px', background: '#fff' }}
        >
          {/* 가이드북 등록 */}
          <div
            style={{
              display: 'flex',
              gap: 12,
              alignItems: 'center',
              flexWrap: 'wrap',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ width: 36, color: '#666' }}>제목</span>
              <Input
                style={{ width: 260 }}
                placeholder="가이드북 제목"
                value={newGuideTitle}
                onChange={(e) => setNewGuideTitle(e.target.value)}
                maxLength={100}
              />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ width: 36, color: '#666' }}>설명</span>
              <Input
                style={{ width: 420 }}
                placeholder="가이드북 설명"
                value={newGuideDescription}
                onChange={(e) => setNewGuideDescription(e.target.value)}
                maxLength={200}
              />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ width: 36, color: '#666' }}>URL</span>
              <Input
                style={{ width: 420 }}
                placeholder="링크 URL"
                value={newGuideLink}
                onChange={(e) => setNewGuideLink(e.target.value)}
              />
            </div>
            <Button
              type="primary"
              onClick={registerCommunityGuidebook}
              loading={isRegisteringGuide}
            >
              등록
            </Button>
          </div>
        </div>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{ marginBottom: 16, padding: '16px', background: '#fff' }}
        >
          {/* 가이드북 목록 */}
          {Array.isArray(guidebookList) && guidebookList.length > 0 ? (
            <List
              itemLayout="horizontal"
              dataSource={guidebookList}
              renderItem={(item) => (
                <List.Item
                  actions={[
                    <Button
                      key="edit"
                      type="primary"
                      onClick={() =>
                        handleUpdateCommunityGuidebook(
                          item.id,
                          item.title,
                          item.description,
                          item.link,
                        )
                      }
                    >
                      수정
                    </Button>,
                    <Button
                      key="delete"
                      type="default"
                      onClick={() => handleDeleteCommunityGuidebook(item.id)}
                    >
                      삭제
                    </Button>,
                  ]}
                >
                  <List.Item.Meta
                    title={
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 8,
                        }}
                      >
                        <span style={{ width: 36, color: '#666' }}>제목</span>
                        <Input
                          placeholder="가이드북 제목"
                          value={item.title}
                          onChange={(e) =>
                            setGuidebookList((prev) =>
                              prev.map((g) =>
                                g.id === item.id
                                  ? { ...g, title: e.target.value }
                                  : g,
                              ),
                            )
                          }
                        />
                      </div>
                    }
                    description={
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 8,
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                          }}
                        >
                          <span style={{ width: 36, color: '#666' }}>설명</span>
                          <Input
                            placeholder="가이드북 설명"
                            value={item.description}
                            onChange={(e) =>
                              setGuidebookList((prev) =>
                                prev.map((g) =>
                                  g.id === item.id
                                    ? { ...g, description: e.target.value }
                                    : g,
                                ),
                              )
                            }
                          />
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                          }}
                        >
                          <span style={{ width: 36, color: '#666' }}>URL</span>
                          <Input
                            placeholder="링크 URL"
                            value={item.link}
                            onChange={(e) =>
                              setGuidebookList((prev) =>
                                prev.map((g) =>
                                  g.id === item.id
                                    ? { ...g, link: e.target.value }
                                    : g,
                                ),
                              )
                            }
                          />
                        </div>
                      </div>
                    }
                  />
                </List.Item>
              )}
            />
          ) : (
            <Typography.Text type="secondary">
              등록된 가이드북이 없습니다.
            </Typography.Text>
          )}
        </div>
      </div>
    </div>
  )
}
